import React from 'react';

const SimpleFrame = (props) => {
  const { children, NotCenter, style } = props;

  return (
    <div className='normalBox'>
      <div className={!NotCenter ? 'center' : ''} style={style}>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default SimpleFrame;
